import { ChartColor, ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import { Label } from 'ng2-charts';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'src/app/_services/report.service';
import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { BeatblipUtils } from 'src/app/consts/beatblip-utils';
import { ExcelService } from 'src/app/_services/excel.service';
import { Chart } from '../latest-report/chart';
import { DatePipe } from '@angular/common';
import alasql from 'alasql';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ProjectService } from 'src/app/_services/project.service';
var XLSX = require('../../../assets/js/xlsx')


@Component({
  selector: 'app-project-summary-report',
  templateUrl: './project-summary-report.component.html',
  styleUrls: ['./project-summary-report.component.scss']
})
export class ProjectSummaryReportComponent implements OnInit {

  @ViewChild('table1') table1: ElementRef;


  projectId: any;
  startDate: any;
  endDate: any;
  status: any;
  serachOs: any;
  searchBrowser: any;
  includeCount: any;
  

  testExecutionStats: any=[];
  showFailReason: boolean =false;


  public chartOptionSelect = ['pie','bar'];
  copyMessage: any;
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  charData: any=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Object> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Automation Summary Detail',
    data: undefined,
  }

  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;
  projectData: any;


  constructor(
    private route: ActivatedRoute,
    private report: ReportService,
    private toastrService : ToastrService,
    private utils: BeatblipUtils,
    private excelService:ExcelService,
    public datePipe: DatePipe,
    private project: ProjectService
  ) { }

  ngOnInit() {
    this.route.paramMap.subscribe((params) => {
      this.projectId = params.get('pid');
      this.startDate = params.get('starDate');
      this.endDate = params.get('endDate');
      this.status = params.get('status');
      //console.log('params',this.projectId);
      this.getSummaryReport(this.projectId,this.startDate,this.endDate,this.status);
      this.project.getProjectById(this.projectId).subscribe(
        (data)=>{
          this.projectData = data;
          this.headerOptions.data = { 
            projectId : this.projectId,
            projectName: data['projectName']
          };
        }
      )
    })
  }

  

  getSummaryReport(pid,startDate,endDate,status){
   this.report.projectSummaryReport(pid, startDate,endDate,status).subscribe(
    (data)=>{
      this.testExecutionStats = data.testExecutionStats;
      let chartObj = new Object();
      chartObj['pass'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "PASS").length:0;
      chartObj['fail'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "FAIL").length:0;
      chartObj['blocked'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "BLOCKED").length:0;
      chartObj['inconclusive'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "INCONCLUSIVE").length:0;
      chartObj['notRun'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "NOTRUN").length:0;
      chartObj['skipped'] = this.testExecutionStats.filter(status => status.status === "PASS").length?this.testExecutionStats.filter(status => status.status === "SKIPPED").length:0;
      this.chartList.push(chartObj);
      this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
      for(let c of this.chartList){
        this.blinkArry.push(Object.values(c));
      }
      this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
      const toNumbers = arr => arr.map(Number);
      var n = toNumbers(this.numarray);
      this.barChartData = [{ data:n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
    })
  }

  onChecked(isChecked: boolean) {
    if(isChecked) {
      this.showFailReason = true;
    } else{
      this.showFailReason = false;
    }
  }
  copyToClipboard(item): void {
    var temporalDivElement = document.createElement("div");
          temporalDivElement.innerHTML = item;
          var result = temporalDivElement.textContent || temporalDivElement.innerText || "";
    this.utils.copyToClipboard(result);
    this.toastrService.clear();
    this.toastrService.success('Copy To Clipboard');
  }

  getFailedReason = function (data) {
    if (data) {
        var regex = /<br\s*[\/]?>/gi;
        return data.replace(regex, "\n");
    } else {
        return data;
    }
};
onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}
  exportToExcel(){
    // var XLSX = require('xlsx')
alasql.setXLSX(XLSX);
// alasql["private"].externalXlsxLib = require('xlsx');
    //Step#							End Time	Duration(seconds)	
    var excelReportData = new Array();
    var counter = 1;
      for (var z = 0; z < this.testExecutionStats.length; z++) {
          var tempObject = new Object();
          tempObject['#'] = counter++;
          tempObject['Test Suite'] = this.testExecutionStats[z].parentTitle;
          tempObject['TC ID'] = this.testExecutionStats[z].testCaseId;
          tempObject['Title'] = this.testExecutionStats[z].title;
          tempObject['Status'] = this.testExecutionStats[z].status;
          tempObject['Failure Reason/Category'] = this.testExecutionStats[z].comment;
          tempObject['Start Time'] = this.datePipe.transform(this.testExecutionStats[z].startDate,'M/d/yy,h:mm a')
          tempObject['End Time'] = this.datePipe.transform(this.testExecutionStats[z].endDate,'M/d/yy,h:mm a')
          tempObject['Duration'] = this.testExecutionStats[z].duration;
          var temporalDivElement = document.createElement("div");
          temporalDivElement.innerHTML = this.testExecutionStats[z].failedReason;
          // //console.log('temporalDivElement',temporalDivElement.innerText);
          
          var result = temporalDivElement.textContent || temporalDivElement.innerText || "";
          if(result==='undefined'){
            tempObject['Failure Reason'] =  JSON.stringify('N/A');
          }else{
            tempObject['Failure Reason'] =  JSON.stringify(result);
          }
          
          // tempObject['Failure Reason'] =  JSON.stringify(result);
          excelReportData.push(tempObject);
      }
      alasql('SELECT * INTO XLSX("report-summary.xlsx",{headers:true}) FROM ?', [excelReportData]);
    // //console.log(excelReportData);
    // this.exportAsXLSX(tempObject)
    this.toastrService.clear();
    this.toastrService.success("Project Summary Report Exported Successfully");
  }
  
  exportAsXLSX(excelReport):void {
    this.excelService.exportAsExcelFile(excelReport, 'Project Summary Report');
  }
}
